import { Link as RouterLink } from 'react-router-dom';
import styled from 'styled-components';
import { media } from '@/styles/responsive';

export const UserNameMenuContainer = styled.div`
  position: relative;
  margin-right: 14px;
`;

export const UserNameMenu = styled.button`
  display: flex;
  background: transparent;
  border: none;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;
  position: relative;
  z-index: 3;
  -webkit-tap-highlight-color: transparent;
  padding: 4px;
  border-radius: 999px;
  transition: opacity 200ms cubic-bezier(0.2, 0.8, 0.4, 1);

  &:hover {
    opacity: 0.85;
  }

  &:active {
    opacity: 0.7;
  }
`;

export const AvatarContainer = styled.div`
  width: 36px;
  height: 36px;
  overflow: hidden;
  border-radius: 50%;
  background: ${(props) => props.theme.colors['primary-60']};
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  flex-shrink: 0;
`;

export const Avatar = styled.img`
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
`;

export const UserName = styled.p`
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: #fff;

  ${media.mobile} {
    display: none;
  }
`;

export const DropDown = styled.div`
  background: #fff;
  border: 2px solid #F4F4F5;
  border-radius: 12px;
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  min-width: 200px;
  box-shadow: 0 4px 16px hsla(0, 0%, 0%, 0.16);
  overflow: hidden;

  ${media.mobile} {
    min-width: 200px;
    right: -8px;
  }
`;

export const Overlay = styled.div`
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  position: fixed;
  z-index: 2;
  background: transparent;
`;

export const OptionsContainer = styled.div`
  z-index: 3;
  position: relative;
  padding: 4px 0;
`;

export const Button = styled.button`
  background: transparent;
  border: none;
  display: block;
  width: 100%;
  cursor: pointer;
  text-align: left;
  -webkit-tap-highlight-color: transparent;

  &:last-child > div {
    border-top: 1px solid #F4F4F5;
    margin-top: 4px;
    padding-top: 12px;
  }
`;

export const Link = styled(RouterLink)`
  display: block;
  width: 100%;
  text-decoration: none;
`;

export const Option = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 16px;
  border-radius: 0;
  transition: background-color 200ms cubic-bezier(0.2, 0.8, 0.4, 1);

  &:hover {
    background-color: #F4F4F5;
  }

  &:active {
    background-color: #E4E4E7;
  }

  ${media.mobile} {
    padding: 12px 16px;
    min-height: 44px;
    gap: 10px;
  }
`;

export const OptionIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  svg {
    color: #4A4B4E;
    width: 20px;
    height: 20px;
  }
`;

export const Label = styled.span`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #09090B;
`;

export const OrgSectionLabel = styled.div`
  font-size: 12px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #71717A;
  padding: 10px 16px 4px;
`;

export const OrgOption = styled(Option)<{ $isActive: boolean }>`
  background-color: ${({ $isActive }) => ($isActive ? '#F4F4F5' : 'transparent')};
`;

export const OrgDivider = styled.div`
  height: 1px;
  background: #F4F4F5;
  margin: 4px 0;
`;
